import React from 'react'
import { emptyFieldStyle, NotFilledBadge } from './shared'

interface Props {
  id: string
  label: string
  placeholder: string
  value: string
  onChange: (value: string) => void
  isEmptyInDrive: boolean
  notFilledLabel: string
  error?: string
  onClearError?: () => void
  multiline?: boolean
  rows?: number
}

export default function DocumentTextFormGroup({
  id,
  label,
  placeholder,
  value,
  onChange,
  isEmptyInDrive,
  notFilledLabel,
  error,
  onClearError,
  multiline = false,
  rows = 2,
}: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.target.value)
    onClearError?.()
  }

  const controlClass = `form-control${error ? ' is-invalid' : ''}`

  return (
    <div className="form-group" style={isEmptyInDrive ? emptyFieldStyle : {}}>
      <label htmlFor={id}>
        {label}
        {isEmptyInDrive && <NotFilledBadge label={notFilledLabel} />}
      </label>
      {multiline ? (
        <textarea
          id={id}
          className={controlClass}
          rows={rows}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
        />
      ) : (
        <input
          type="text"
          id={id}
          className={controlClass}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
        />
      )}
      {error && (
        <div className="invalid-feedback" style={{ display: 'block' }}>
          {error}
        </div>
      )}
    </div>
  )
}
